import SiafLiteApiRepository from "../../external/siafLiteApi";

class ClienteService {
  constructor() {
    this.urlBase = "/integracao/clientes";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  async getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  atualizarDependentes(id, body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/dependentes`).put(
      id,
      body
    );
  }
}

export default ClienteService;
